import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { obfuscatePath, recordEvent } from '../analytics/product';

export function useLocationChange() {
    const location = useLocation();

    useEffect(() => {
        // RUN-809: never spread the whole `location`. `search`, `hash`, `state` and `key` can carry
        // referral/report/member ids and other PII straight into Amplitude, and `pathname` obfuscation
        // alone does not touch them. Emit only an allowlisted, normalised subset.
        recordEvent({
            name: 'location_change',
            attributes: {
                pathname: obfuscatePath(location.pathname),
            },
        });
    }, [location]);
}
